<template>
  <div>
    <Modal class="my-modal" v-model="visible" :title="title" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" :label-width="90" class="formGauge">
        <FormItem label="文案" prop="copywriting" :rules="$units.formRule.required('请输入文案', 'change')">
          <div class="textBox">
            <textarea v-model="formData.copywriting" id="input" placeholder="请输入" class="textarea"
              :class="changeWriting ? 'changeWriting' : ''" @change="changeRequired" />
            <img src="@/assets/images/icon/org/emoji.png" @click.stop="showDialog = !showDialog" class="emojiBtn" />
            <VEmojiPicker v-show="showDialog" @select="selectEmoji" class="emojiSearch" id="showEmoji" />
          </div>
          <!-- <VueEmoji ref="emoji" v-model="formData.copywriting" width="100%" height @input="oninput" /> -->
        </FormItem>
        <FormItem label="引用类型" prop="type">
          <Select v-model="formData.type" transfer placeholder="请选择引用类型" @on-change="changeUploadType">
            <Option value="6">图片</Option>
            <Option value="7">视频</Option>
            <Option value="8">文章</Option>
          </Select>
        </FormItem>
        <FormItem label="图片" prop="imglinkContent" v-if="formData.type == '6'" key="imglinkContent">
          <Dropdown :transfer="true" trigger="hover" placement="bottom-start"
            transfer-class-name="salesman-manage-dropdown-menu table-btn" @on-click="dropdownClick($event)">
            <Button type="primary">
              <span style="margin-right: 5px;width: 65px;height: 30px;">上传</span>
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <Upload ref="upload" :show-upload-list="false" :before-upload="handleUpload" action="/">
                <DropdownItem name="local">从本地上传</DropdownItem>
              </Upload>
              <DropdownItem name="manage">从海报管理选择</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <div class="img-list">
            <div class="img" v-for="(url, index) in formData.linkContent" :key="index">
              <div class="img-cover">
                <img src="@/assets/images/icon/org/openImg.png" @click.stop="handleView(url, index)" />
                <img src="@/assets/images/icon/org/dustbin.png" @click.stop="handleRemove(url)" />
              </div>
              <img class="imgUrl" :src="url" :ref="'img' + index" :preview="_uid" width="100px" height="132px" />
            </div>
          </div>
        </FormItem>
        <FormItem label="上传视频" prop="linkContent" v-if="formData.type == '7'" class="proImg" key="videolinkContent"
          :rules="$units.formRule.arrRequired('请上传视频', 'change')">
          <Progress v-if="isUpload" :stroke-width="5" :percent="progress" hide-info
            style="width: 30%; display: block; margin: 0 auto" class="progress"></Progress>
          <Upload multiple type="drag" action="/" :before-upload="handleUploadVideo" class="videoBoxContent">
            <div v-if="formData.linkContent.length == 0" class="addIcon">
              <Icon type="ios-add" size="52" style="color: #C0C4CC"></Icon>
            </div>
            <video v-if="formData.linkContent.length > 0" controls="controls" width="400" :src="formData.linkContent[0]"
              autoplay></video>
          </Upload>
        </FormItem>
        <FormItem label="视频图片" prop="linkContentimg" v-if="formData.type == '7' && formData.linkContent.length > 0" key="linkContentimg">
          <uploadNew fileType="img" v-model="formData.videoCoverArr" @remove="$set(formData, 'videoCoverArr', '')"
            @change="changeVideoCover"></uploadNew>
        </FormItem>
        <FormItem label="文章" prop="articlelinkContent" v-if="formData.type == '8'" key="articlelinkContent">
          <div class="article">
            <Button type="primary" @click="$refs.articleModal.open()">
              选择文章
            </Button>
            <div class="articleBox" v-if="articleList.length > 0" @click="clickAr">
              <div>
                <span class="articleTitle">{{ articleList[0].title }}</span>
                <span class="useTime">{{ articleList[0].useTime }}</span>
              </div>
              <img :src="articleList[0].coverImg" />
            </div>
          </div>
        </FormItem>
        <FormItem label="所属栏目" prop="columnIds" :rules="$units.formRule.arrRequired('请选择所属栏目', 'change')">
          <selectTreeOld :data="columnList" :multiple="true" :size="null" placeholder="请选择" :single="true"
            :showParentNode="true" :selectAllChildren="true" :checkToParent="true" v-model="formData.columnIds"></selectTreeOld>
        </FormItem>
        <FormItem label="关联产品" prop="productCodes">
          <Select :label-in-value="true" v-model="formData.productCodes" placeholder="请选择" transfer filterable clearable multiple>
            <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{
              product.productName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="标签" prop="tags">
          <add-tag v-model="formData.tags" :color="'#EFF2F5'" ref="tag" :maxlength="5" placeholder="输入一个标签后回车确定，每个最多5个字，最多3个"></add-tag>
        </FormItem>
        <FormItem label="发布用户" prop="userId" :rules="$units.formRule.required('请选择发布用户')">
          <Select v-model="formData.userId" placeholder="请选择" filterable clearable>
            <Option :value="item.id" v-for="item in userListArr" :key="item.id">{{ item.nickName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="展示机构" prop="orgIdList" :rules="$units.formRule.arrRequired('请选择展示机构', 'change')">
          <selectTree v-model="formData.orgIdList" :multiple="true" :maxTagCount="5" type="4" ref="selectTreeRef"
            :orgId="formData.buzOrganId" @treeClick="treeClick" :checkChild="false" @getTreeData="getTreeData"
            :showCloseIcon="false"></selectTree>
        </FormItem>
        <FormItem label="创建人" v-if="submitType == 'edit'" key="createName">
          <span style="line-height: 34px;">{{ formData.createName }}</span>
        </FormItem>
        <FormItem label="创建时间" v-if="submitType == 'edit'" key="createTime">
          <span style="line-height: 34px;">{{ formData.createTime }}</span>
        </FormItem>
        <FormItem label="最后更新人" v-if="submitType == 'edit'" key="updateName">
          <span style="line-height: 34px;">{{ formData.updateName }}</span>
        </FormItem>
        <FormItem label="更新时间" v-if="submitType == 'edit'" key="updateTime">
          <span style="line-height: 34px;">{{ formData.updateTime }}</span>
        </FormItem>
      </Form>

      <div class="ivu-modal-footer">
        <Button type="primary" @click="visible = false" ghost>取消</Button>
        <Button type="primary" @click="submit('1')" v-preventReClick>保存</Button>
        <Button type="primary" ghost @click="openPreviewModal">预览</Button>
        <Button type="primary" @click="submit('2')" v-if="publish" v-preventReClick>保存并发布</Button>
      </div>
    </Modal>
    <posterManagementModal ref="posterManagement" @uploadImg="handleUpload" @getImg="getImg"
      :linkContent="formData.linkContent"></posterManagementModal>
    <articleModal ref="articleModal" @changeArticle="changeArticle"></articleModal>
    <previewModal ref="previewModal" :articleList="articleList"></previewModal>
  </div>
</template>

<script>
// import VueEmoji from 'emoji-vue'
import { VEmojiPicker } from 'v-emoji-picker'
import selectTreeOld from '@/components/commons/selectTree';
import selectTree from '@/components/system/selectTree3';
import addTag from '@/components/commons/addTag';
import { uploadVideoFile, uploadFile } from '@/api/httpList';
import uploadNew from '@/components/commons/uploadNew';
import posterManagementModal from "./posterManagementModal"
import articleModal from './articleModal'
import previewModal from './previewModal'
export default {
  components: {
    // VueEmoji,
    VEmojiPicker,
    selectTreeOld,
    addTag,
    selectTree,
    uploadNew,
    posterManagementModal,
    articleModal,
    previewModal
  },
  data() {
    return {
      visible: false,
      isUpload: false,
      showDialog: false,
      changeWriting: false,
      publish:true,
      title: '新增',
      progress: 0,
      formData: {
        videoCover: '',
        videoCoverArr: [],
        linkContent: [],
        type: '6',
        columnIds: []
      },
      previewId: null,
      columnList: [],
      productListArr: [],
      userListArr: [],
      treeData: [],//单独设置机构树
      data: {},
      articleList: [],
      submitType: 'add'
    }
  },
  created(){
    document.addEventListener('click',(e)=>{
      const showEmoji= document.getElementById("showEmoji");
      if(showEmoji){
        if(!showEmoji.contains(e.target)){
          this.showDialog = false
        }
      }
    })
  },
  methods: {
    clickAr() {
      window.open(this.articleList[0].url, "_blank")
    },
    changeArticle(item) {
      this.$nextTick(() => {
        this.articleList = [item]
      })
      this.formData.linkContent = [item.id]
    },
    changeRequired() {
      if (!this.formData.copywriting) {
        this.changeWriting = true
      } else {
        this.changeWriting = false
      }
      this.$refs.form.validateField('copywriting');
    },
    selectEmoji(emoji) {// 选择emoji后调用的函数
      let input = document.getElementById("input")
      let startPos = input.selectionStart
      let endPos = input.selectionEnd
      let txt = input.value
      let resultText = txt.substring(0, startPos) + emoji.data + txt.substring(endPos)
      input.value = resultText
      input.focus()
      input.selectionStart = startPos + emoji.data.length
      input.selectionEnd = startPos + emoji.data.length
      this.formData.copywriting = resultText
    },
    openPreviewModal() {
      if (!this.formData.copywriting) {
        this.changeWriting = true
      } else {
        this.changeWriting = false
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.previewModal.open(this.formData)
        }
      })
    },
    submit(type) {
      let url, data
      if (this.submitType == 'add') {
        url = '/buz/friendsCircle/add'
      } else {
        url = '/buz/friendsCircle/edit'
      }
      if (this.submitType == 'edit' && this.formData.isPublish == '1') {
        data = this.formData
      } else {
        data = {
          ...this.formData,
          isPublish: type == '1' ? '0' : '1'
        }
      }
      if(this.formData.type == '6' && this.formData.linkContent.length==0){
        this.$notice.error('至少选择一张选择图片')
        return
      }else if(this.formData.type == '8' && this.formData.linkContent.length==0){
        this.$notice.error('至少选择一篇文章')
        return
      }
      console.log(data);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http({
            url: url,
            type: "POST",
            data: data
          }).then(res => {
            this.visible = false
            this.$emit('getList')
          })
        }
      })
    },
    changeVideoCover() {
      if (this.formData.videoCoverArr && this.formData.videoCoverArr[0]) {
        this.$set(this.formData, "videoCover", this.formData.videoCoverArr[0].path)
      }
    },
    // 上传视频相关函数
    handleUploadVideo(file) {
      this.progress = 0;
      if (!/\.(mp4|webM|ogg)$/.test(file.name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传视频格式");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      this.isUpload = true;
      uploadVideoFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(2);
          }
        }
      })
        .then(res => {
          this.formData.linkContent = [res.data.videoUrl];
          this.formData.videoCoverArr = [{ path: res.data.videoCover }];
          this.$set(this.formData, "videoCover", this.formData.videoCoverArr[0].path)
          this.progress = 100;
          this.isUpload = false;
        })
        .catch(e => {
          this.formData.linkContent = null;
          this.progress = 0;
          this.isUpload = false;
        });
      return false;
    },
    //切换上传文件类型
    changeUploadType() {
      this.formData.linkContent = []
      this.progress = 0
      this.formData.videoCover = ''
      this.formData.videoCoverArr = []
      this.articleList = []
    },

    //上传图片相关函数
    getImg(val) {
      if (val) {
        this.formData.linkContent.push(...val)
      }
    },
    checkType(path) {
      return path && path
        .split(".")
        .pop()
        .toLowerCase();
    },
    handleView(path, index) {
      if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
        this.$refs['img' + index][0].click();
        this.$previewRefresh();
      } else {
        window.open(path, "_blank");
      }
    },
    handleRemove(path) {
      this.formData.linkContent.forEach((item, index) => {
        if (item == path) {
          this.formData.linkContent.splice(index, 1)
        }
      })
    },
    handleUpload(file) {
      const reg = /\.(png|jpg|jpeg)$/;
      if (!reg.test(file.name.toLowerCase())) {
        this.$Message.error(`上传格式不正确，请上传jpg/jpeg/png格式文件`);
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then(res => {
        if (this.formData.linkContent.length < 9) {
          this.formData.linkContent.push(res.data[0].path)
        } else {
          this.$notice.msg("最多上传9张")
        }

      });
      return false;
    },
    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    deepCheck(treeData) {
      treeData.forEach(item => {
        item.checked = true;
        if (item.children.length) {
          this.deepCheck(item.children)
        }
      })
    },
    // 权限勾选
    treeClick(data) {
      if (data.checked) {
        if (this.treeData[0].id != data.id) {//当前节点不是顶级的直接子级
          this.findTreeParent(this.treeData, data.parentId);
        }
        this.findTreeList([data], true);//勾选子级
      } else {
        this.findTreeList([data], false);//去掉子级勾选
      }
      this.$refs.selectTreeRef.setSelectIdByChecked();
    },
    findTreeParent(tree, id) {
      tree.find(item => {
        if (item.id == id) {
          this.$set(item, 'checked', true)
          if (!item.isTop) {//存在非顶级继续查找
            return this.findTreeParent(this.treeData, item.parentId);
          } else {
            return true;
          }
        }
        if (item.children && item.children.length) {
          return this.findTreeParent(item.children, id)
        }
        return false;
      })
    },
    findTreeList(tree, checked) {
      tree.forEach(item => {
        this.$set(item, 'checked', checked)
        if (item.children && item.children.length) {
          this.findTreeList(item.children, checked)
        }
      })
    },
    // 用户
    getUserList() {
      this.$http({
        url: "/buz/friendsCircleUser/querySelectList",
        type: "post",
        data: {},
      }).then((res) => {
        this.userListArr = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    // 产品
    getProductList() {
      this.$http({
        url: "/buz/productBase/read/short/list",
        type: "post",
        data: {
          pageNo: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        this.productListArr = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    getColumnList() {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: "POST",
        data: {
          type: 3,
        }
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      })
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },
    // 上传按钮
    dropdownClick(name) {
      if (name == 'manage') {
        this.$refs.posterManagement.open()
      }
    },
    open(item) {
      this.visible = true
      this.showDialog = false
      this.formData = {
        videoCover: '',
        videoCoverArr: [],
        linkContent: [],
        type: '6',
        columnIds: [],
        copywriting: '',
        tags:''
      }
      this.$refs.tag.text = ''
      this.articleList = []
      this.$refs.form && this.$refs.form.resetFields();
      this.getColumnList()
      this.getProductList()
      this.getUserList()
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      });
      if (item) {
        this.title = '编辑'
        this.getOneDetail(item.id)
        this.submitType = 'edit'
      } else {
        this.title = '新增'
        this.submitType = 'add'
        this.publish = true
      }
    },
    // 查询单条数据
    getOneDetail(id) {
      this.$http({
        url: '/buz/friendsCircle/read/detail',
        type: "GET",
        data: {
          id: id,
        }
      }).then(res => {
        this.formData = res.data
        if (this.formData.article) {
          this.articleList = [this.formData.article]
        }

        if (this.formData.videoCover) {
          this.formData.videoCoverArr = [{ path: this.formData.videoCover }]
        }

        if(this.submitType == 'edit' && this.formData.isPublish == '1'){
          this.publish = false
        }else{
          this.publish =true
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-tag-color-white{
  color: #3C464F !important;
}
/deep/ .ivu-tag{
  margin-bottom: 10px;
}
/deep/ textarea::-webkit-input-placeholder {
  color: #CED1D5;
}

/deep/.ivu-select-multiple .ivu-tag{
  max-width: 85% !important;
}

/deep/ textarea::-moz-placeholder {
  color: #CED1D5;
}

/deep/ .ivu-upload-select {
  width: 100%;
}

/deep/ .emoji-picker-icon {
  top: 70px;
}

/deep/ .ivu-form-item-content{
  line-height: 24px !important;
}

/deep/ .demo-upload-list {
  width: 212px !important;
  height: 120px !important;

  img {
    width: 100% !important;
    height: 100% !important;
  }
}

/deep/ .uploadBoxs {
  width: 212px !important;
  height: 120px !important;
}

.textBox {
  position: relative;

  .textarea {
    width: 100%;
    min-height: 110px;
    border: 1px solid #E3E5E8;
    border-radius: 2px;
    padding: 0 7px;

    &:focus {
      border: 1px solid #4f8aff;
      outline: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(35, 109, 255, .2);
      box-shadow: 0 0 0 2px rgba(35, 109, 255, .2);
    }

    &.changeWriting {
      border: 1px solid #ed4014;
      box-shadow: none;
    }

    /deep/ textarea::-webkit-input-placeholder {
      color: #CED1D5;
    }

    /deep/ textarea::-moz-placeholder {
      color: #CED1D5;
    }
  }

  .emojiBtn {
    position: absolute;
    bottom: 20px;
    right: 20px;
    width:14px;
    cursor: pointer;
  }

  .emojiSearch {
    position: fixed;
  }

  /deep/ .container-search {
    display: none;
  }
}


.proImg {
  position: relative;
}

.progress {
  position: absolute;
  top: 75px;
  left: 45px;
  z-index: 100;
}

.img-list {
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;

  .img {
    position: relative;
    width: 132px;
    height: 134px;
    border: 1px solid #DCDFE6;
    margin-right: 15px;
    margin-top: 10px;

    .img-cover {
      position: absolute;
      right: 16px;
      cursor: pointer;
    }
    img{
      object-fit: cover;
      object-position: top;
    }
    .imgUrl {
      margin: 0 16px;
    }
  }

}

/deep/ .videoBoxContent {
  width: 212px;
  height: 120px;

  .addIcon {
    padding: 30px 0;
  }

  video {
    width: 100%;
    height: 100%;
  }

  .ivu-upload-drag {
    width: 100%;
    height: 100%;
    background: #F7F7F7;
    border-radius: 4px;
  }
}

.article {
  .articleBox {
    width: 100%;
    height: 98px;
    background: #F5F7F9;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    img {
      width: 100px;
      height: 68px;
      object-fit: cover;
    }

    .articleTitle {
      display: -webkit-box;
      width: 220px;
      height: 36px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      line-height: 18px;
      color: #515C6F;
    }

    .useTime {
      width: 61px;
      height: 14px;
      font-size: 12px;
      font-family: Arial;
      font-weight: 400;
      line-height: 14px;
      color: #727C8E;
    }
  }

}
</style>